var map = {
	"./access-denied/access-denied.module": [
		"./src/app/access-denied/access-denied.module.ts",
		"access-denied.module"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./blank-page/blank-page.module": [
		"./src/app/layout/blank-page/blank-page.module.ts",
		"blank-page.module"
	],
	"./bs-component/bs-component.module": [
		"./src/app/layout/bs-component/bs-component.module.ts",
		"common",
		"bs-component.module"
	],
	"./bs-element/bs-element.module": [
		"./src/app/layout/bs-element/bs-element.module.ts",
		"common",
		"bs-element.module"
	],
	"./charts/charts.module": [
		"./src/app/layout/charts/charts.module.ts",
		"common",
		"charts.module"
	],
	"./customer/add.module": [
		"./src/app/layout/customer/add.module.ts",
		"common",
		"add.module.0"
	],
	"./customer/cust.module": [
		"./src/app/layout/customer/cust.module.ts",
		"common",
		"cust.module"
	],
	"./customer/detail-cust.module": [
		"./src/app/layout/customer/detail-cust.module.ts",
		"common",
		"detail-cust.module"
	],
	"./customer/issue_report_list.module": [
		"./src/app/layout/customer/issue_report_list.module.ts",
		"common",
		"issue_report_list.module"
	],
	"./customer/update-cust.module": [
		"./src/app/layout/customer/update-cust.module.ts",
		"common",
		"update-cust.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/layout/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./form/form.module": [
		"./src/app/layout/form/form.module.ts",
		"common",
		"form.module"
	],
	"./grid/grid.module": [
		"./src/app/layout/grid/grid.module.ts",
		"common",
		"grid.module"
	],
	"./hadmin/hadmin.module": [
		"./src/app/layout/hadmin/hadmin.module.ts",
		"hadmin.module"
	],
	"./hotel-admin/add-admin.module": [
		"./src/app/layout/hotel-admin/add-admin.module.ts",
		"common",
		"add-admin.module"
	],
	"./hotel-admin/detail-admin.module": [
		"./src/app/layout/hotel-admin/detail-admin.module.ts",
		"common",
		"detail-admin.module"
	],
	"./hotel-admin/hotel-admin.module": [
		"./src/app/layout/hotel-admin/hotel-admin.module.ts",
		"common",
		"hotel-admin.module"
	],
	"./hotel-admin/update-admin.module": [
		"./src/app/layout/hotel-admin/update-admin.module.ts",
		"common",
		"update-admin.module"
	],
	"./issue_report/issue_report.module": [
		"./src/app/layout/issue_report/issue_report.module.ts",
		"common",
		"issue_report.module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"common",
		"layout.module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"./not-found/not-found.module": [
		"./src/app/not-found/not-found.module.ts",
		"not-found.module"
	],
	"./org_profile/org_profile.module": [
		"./src/app/layout/org_profile/org_profile.module.ts",
		"common",
		"org_profile.module"
	],
	"./padmin/padmin.module": [
		"./src/app/layout/padmin/padmin.module.ts",
		"padmin.module"
	],
	"./police-user/add-police-user.module": [
		"./src/app/layout/police-user/add-police-user.module.ts",
		"common",
		"add-police-user.module"
	],
	"./police-user/detail-police-user.module": [
		"./src/app/layout/police-user/detail-police-user.module.ts",
		"common",
		"detail-police-user.module"
	],
	"./police-user/police-user.module": [
		"./src/app/layout/police-user/police-user.module.ts",
		"common",
		"police-user.module"
	],
	"./police-user/update-police-user.module": [
		"./src/app/layout/police-user/update-police-user.module.ts",
		"common",
		"update-police-user.module"
	],
	"./profile/profile.module": [
		"./src/app/layout/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"./reports/report.module": [
		"./src/app/layout/reports/report.module.ts",
		"common",
		"report.module"
	],
	"./rooms/add.module": [
		"./src/app/layout/rooms/add.module.ts",
		"common",
		"add.module.1"
	],
	"./rooms/addproof.module": [
		"./src/app/layout/rooms/addproof.module.ts",
		"common",
		"addproof.module"
	],
	"./rooms/addroom.module": [
		"./src/app/layout/rooms/addroom.module.ts",
		"common",
		"addroom.module"
	],
	"./rooms/edithousekeeping.module": [
		"./src/app/layout/rooms/edithousekeeping.module.ts",
		"common",
		"edithousekeeping.module"
	],
	"./rooms/housekeeping.module": [
		"./src/app/layout/rooms/housekeeping.module.ts",
		"common",
		"housekeeping.module"
	],
	"./rooms/proofs.module": [
		"./src/app/layout/rooms/proofs.module.ts",
		"common",
		"proofs.module"
	],
	"./rooms/rooms.module": [
		"./src/app/layout/rooms/rooms.module.ts",
		"common",
		"rooms.module"
	],
	"./rooms/updateproof.module": [
		"./src/app/layout/rooms/updateproof.module.ts",
		"common",
		"updateproof.module"
	],
	"./rooms/updateroom.module": [
		"./src/app/layout/rooms/updateroom.module.ts",
		"common",
		"updateroom.module"
	],
	"./sadmin/sadmin.module": [
		"./src/app/layout/sadmin/sadmin.module.ts",
		"sadmin.module"
	],
	"./server-error/server-error.module": [
		"./src/app/server-error/server-error.module.ts",
		"server-error.module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"common",
		"signup.module"
	],
	"./staff/add.module": [
		"./src/app/layout/staff/add.module.ts",
		"common",
		"add.module"
	],
	"./staff/detail-staff.module": [
		"./src/app/layout/staff/detail-staff.module.ts",
		"common",
		"detail-staff.module"
	],
	"./staff/staff.module": [
		"./src/app/layout/staff/staff.module.ts",
		"common",
		"staff.module"
	],
	"./staff/update-staff.module": [
		"./src/app/layout/staff/update-staff.module.ts",
		"common",
		"update-staff.module"
	],
	"./tables/tables.module": [
		"./src/app/layout/tables/tables.module.ts",
		"common",
		"tables.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main